import React from "react";
import { Box, Typography, Divider, Button } from "@mui/material";

const FinancialAnalysisViewer = ({ response }) => {
    const logoUrl =
        "https://figk-12.com/static/media/fig_CROP.cb0d7cf4314c63ba05ee.png";

    const sections = [
        { title: "Performance", content: response?.Performance || "No data available.", color: "#007BFF" },
        { title: "Trends", content: response?.Trends || "No data available.", color: "#28A745" },
        { title: "Improvement", content: response?.Improvement || "No data available.", color: "#FFC107" },
        { title: "Excellence", content: response?.Excellence || "No data available.", color: "#17A2B8" },
        { title: "Summary", content: response?.Summary || "No data available.", color: "#6C757D" },
    ];

    const handlePrint = () => {
        const html = document.getElementById("financial-analysis-report")?.innerHTML;
        if (!html) return alert("No report available to print.");
        const backup = document.body.innerHTML;
        document.body.innerHTML = html;
        window.print();
        document.body.innerHTML = backup;
    };

    return (
        <Box
            id="financial-analysis-report"
            sx={{
                backgroundColor: "#f8f9fa",
                padding: "20px",
                borderRadius: "10px",
                maxWidth: "800px",
                margin: "20px auto",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                }}
            >
                <Box
                    component="img"
                    src={logoUrl}
                    alt="FIG Logo"
                    sx={{ width: "100px", height: "100px", objectFit: "cover" }}
                />
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: "#007BFF",
                        color: "#ffffff",
                        "&:hover": { backgroundColor: "#0056b3" },
                    }}
                    onClick={handlePrint}
                >
                    Print Report
                </Button>
            </Box>

            {sections.map((sec, idx) => (
                <Box key={idx} sx={{ marginBottom: "20px" }}>
                    <Typography
                        variant="h6"
                        sx={{
                            color: sec.color,
                            fontWeight: "bold",
                            marginBottom: "10px",
                            fontSize: "18px",
                        }}
                    >
                        {sec.title}
                    </Typography>
                    <Typography
                        sx={{
                            color: "#333",
                            lineHeight: 1.6,
                            fontSize: "14px",
                            fontFamily: "Arial, sans-serif",
                        }}
                    >
                        {sec.content}
                    </Typography>
                    {idx < sections.length - 1 && <Divider sx={{ margin: "20px 0" }} />}
                </Box>
            ))}
        </Box>
    );
};

export default FinancialAnalysisViewer;
